module.exports = __webpack_public_path__ + "static/assets/d53d7daab42f873aa8e7cbe18cc28401.svg";